// Human-readable work duration — "5m" for short punches, "8h" for full days,
// "1h 30m" in between. Plain decimal hours (e.g. "0.1h") read poorly for the
// short end, which is exactly the range worth calling out.
export const formatWorkDuration = (minutes) => {
  if (minutes == null || Number.isNaN(Number(minutes))) return null;
  const total = Math.max(0, Math.round(Number(minutes)));
  const hours = Math.floor(total / 60);
  const mins = total % 60;
  if (hours === 0) return `${mins}m`;
  if (mins === 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
};
